'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Input = require('stampy/lib/component/Input');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Input).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/react-goose/lib/Input.js
// module id = 112
// module chunks = 35783957827783 114276838955818 162898551421021